import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CompanyService } from "src/app/services/company.service";
import { CustomerService } from "src/app/services/customer.service";
// import { ServiceCenterService } from "src/app/services/service-center.service";
import { AWBService } from "src/app/services/operations/awb.service";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AWBDeleteActionsRenderer } from "../../shared/ag-grid/cell-renderers/awb-delete.component";
import { NetworkService } from "src/app/services/network.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { MiscService } from "src/app/services/misc/misc.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
  selector: 'app-awbconfig',
  templateUrl: './awbconfig.component.html',
  styleUrls: ['./awbconfig.component.scss']
})
export class AwbConfigComponent implements OnInit, AfterViewInit {
  awbStockForm: FormGroup;
  awbConfigForm: FormGroup;
  isFormSubmitted: boolean;
  Id: number;
  countList: any[] = [];
  companyList: any[] = [];
  customerList: any[] = [];
  serviceCenterList: any[] = [];
  configDetail: any[] = [];
  isStockTabActive = true;
  isAddDisable = false;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight'
  }
  columnDefs = [
    { headerName: 'AWB No. From', field: 'seriesfrom', maxWidth: 140 },
    { headerName: 'AWB No. To', field: 'seriesto', maxWidth: 140 },
    { headerName: 'Count', field: 'count', maxWidth: 80 },
    {
      headerName: 'In Use',
      field: 'inuse',
      cellRenderer: (params: { value: boolean; }) => {
        let statusHtml = '<span class="badge badge-pill bg-warning">No</span>';
        if (params.value) {
          statusHtml = '<span class="badge badge-pill bg-success">Yes</span>';
        }
        return statusHtml;
      },
      maxWidth: 80
    },
    { headerName: 'Company', field: 'companyname', minWidth: 150 },
    { headerName: 'Service Center', field: 'servicecentername', minWidth: 150 },
    { headerName: 'Customer', field: 'customername', minWidth: 150 },
    {
      headerName: 'Created At',
      field: 'createdat',
      maxWidth: 100
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: AWBDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      maxWidth: 80
    },
  ];

  rowData = [];
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private awbService: AWBService,
    private companyService: CompanyService,
    private customerService: CustomerService,
    private networkService: NetworkService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private miscService: MiscService,
    private configService: ConfigService,
    private titleService: Title,
    private utilities: Utilities,

  ) {
    titleService.setTitle('AWB');
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.countList = [20, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 50000, 100000, 500000];
    this.awbStockForm = this.formBuilder.group({
      ddlCompanies: [null],
      txtSeriesFrom: [null, [Validators.required]],
      txtPrefix: [null],
      ddlCount: [null, Validators.required],
      ddlCustomers: [null],
      ddlServiceCenters: [null],
    });

    this.awbConfigForm = this.formBuilder.group({
      configDetails: this.formBuilder.array([])
    });
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.isFormSubmitted = false;
    this.bindConfigs();
    this.bindStocks();
    this.bindCompanies();
    this.bindServiceCenter();
    this.appCoreService.SelectedServiceCenter().subscribe(val => {
      this.bindCustomer(val);
    })

    this.checkPermission();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.awbStockForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData(); 
    const permission = userData.config.filter(x => x.categoryname === 'AWBStock');
    if (permission.length) {
        this.permConfig.isViewAllowed = permission[0].view;
        this.permConfig.isAddAllowed = permission[0].add;
        this.permConfig.isEditAllowed = permission[0].edit;
        this.permConfig.isDeleteAllowed = permission[0].delete;
    }
}

  onStartWithInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z]/g, '').slice(0, 5); // Keep only alphabets, limit to 5 characters
    const formControl = this.awbStockForm.get('txtPrefix');
    if (formControl) {
      formControl.setValue(input.value, { emitEvent: false });
    }
  }

  onSeriesFromInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '').slice(0, 15); // Keep only numbers, limit to 15 characters
    const formControl = this.awbStockForm.get('txtSeriesFrom');
    if (formControl) {
      formControl.setValue(input.value, { emitEvent: false });
    }
  }

  updateAwbConfigForm() {
    const configDetailsArray = this.awbConfigForm.get('configDetails') as FormArray;
    configDetailsArray.clear();
    this.configDetail.forEach(item => {
      configDetailsArray.push(this.formBuilder.group({
        title: [item.title],
        code: [item.code],
        ischecked: [false]
      }))
    })
  }

  bindCompanies() {
    try {
      this.companyService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.companyList = res.data;
          const defaultCompanyObj = this.companyList.filter(x => x.isdefault === true)[0]?.id;
          this.awbStockForm.get('ddlCompanies')?.setValue(defaultCompanyObj);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindCustomer(val) {
    this.customerService.GetAll({ scid: val, isactive: true }).subscribe((res) => {
      if (res && res.success) {
        this.customerList = res.data;
      }
    })
  }
  // GetAllServiceCenters
  bindServiceCenter() {
    this.networkService.GetAllServiceCenters({ isactive: true }).subscribe((res) => {
      if (res && res.success) {
        this.serviceCenterList = res.data;
      }
    })
  }

  bindStocks(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.awbService.GetAllStockList({ refresh: refresh }).subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        }
      })
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  addStock() {
    try {
      this.isFormSubmitted = true;
      if (this.awbStockForm.invalid) {
        return;
      }
      this.isAddDisable = true;
      const requestObj = {
        id: this.Id,
        prefix: this.awbStockForm.get('txtPrefix')?.value,
        seriesfrom: this.awbStockForm.get('txtSeriesFrom').value,
        count: this.awbStockForm.get('ddlCount').value,
        companyid: this.awbStockForm.get('ddlCompanies').value,
        customerid: this.awbStockForm.get('ddlCustomers').value,
        servicecenterid: this.awbStockForm.get('ddlServiceCenters').value
      }
      this.ngxLoaderService.start();
      this.awbService.AddStocks(requestObj).subscribe((response) => {
        if (response) {
          this.ngxLoaderService.stop();
          if (response?.data?.err_msg) {
            this.isAddDisable = false;
            // this.awbStockForm.get('txtPrefix').reset();
            return this.appCoreService.showMessage(response.data.err_msg, 'Duplication error', 'error');
          }
          if (response?.success) {
            this.ngxLoaderService.stop();
            this.resetForm();
            this.openConfirmationDialog("Record Added Successfully");
          }
        }
      });
    }
    catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  deleteAction(cell: any) {
    if (cell && cell.id) {
      this.deleteConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }
  }

  async openConfirmationDialog(msg: any,) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      // this.router.navigate(['/config/awb']);
      // this.bindStockInfo();
      this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
      this.bindStocks(true);
    }
  }


  async deleteConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);

    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.awbService.DeleteStocks(id).subscribe((res) => {
          if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindStocks(true);
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  formateDate(date?: any) {
    const inputDate = date != null || undefined ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const dateString = `${day}-${month}-${year}`;
    return { dateString };
  }

  resetForm(): void {
    let prefix = this.awbStockForm.get('txtPrefix').value
    this.awbStockForm.reset();
    this.isFormSubmitted = false;
    this.isAddDisable = false;
    this.awbStockForm.get('txtPrefix').setValue(prefix);
  }

  bindConfigs() {
    this.miscService.GetMasterConfigs('AWB').subscribe((res) => {
      if (res && res.success) {
        console.log("this.configDetail", res.data);
        this.configDetail = res.data;
        this.updateAwbConfigForm();
        this.bindAwbConfig();
      }
    })
  }

  bindAwbConfig() {
    this.configService.GetAll().subscribe((res) => {
      if (res?.success) {
        const awbConfig: any = res?.data[0]?.awbconfig ?? [];
        console.log("awbConfig", awbConfig);
        const configDetailsArray = this.awbConfigForm.get('configDetails') as FormArray;
        console.log("configDetailsArray", configDetailsArray);
        const configDetailMap = new Map(this.configDetail.map((configItem, index) => [configItem.code, index]));
        console.log("configDetailMap", configDetailMap);
        for (let key in awbConfig) {
          const detailIndex = configDetailMap.get(key);
          if (detailIndex !== undefined) {
            const detailFormGroup = configDetailsArray.at(detailIndex) as FormGroup;
            detailFormGroup.patchValue({ ischecked: awbConfig[key] });
          }
        }
      }
    })
  }

  upsertAwbConfig() {
    try {
      if (this.awbConfigForm.valid) {
        const formValues = this.awbConfigForm.getRawValue();
        const awbConfigData = formValues.configDetails.reduce((acc: any, item: any) => {
          acc[item.code] = item.ischecked;
          return acc;
        }, {});

        const requestObj = {
          type: 'awb',
          configDetails: awbConfigData
        };
        this.ngxLoaderService.start();
        this.configService.ManageConfigs(requestObj).subscribe((res) => {
          if (res && res.success) {
            this.appCoreService.showMessage('Record Saved Successfully', 'Success', 'success');
            this.ngxLoaderService.stop();
          }
        })
      }
    } catch (err) {
      this.ngxLoaderService.stop();
    }
  }

  get configDetails(): FormArray {
    return this.awbConfigForm.get('configDetails') as FormArray;
  }
}